import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components/Link'
import { useHomeLink } from '~/hooks/useHomeLink'

export const HomeButton = (): React.ReactElement => {
  const { t } = useTranslation('menu')
  const homeLink = useHomeLink()

  return (
    <Link className="flex items-center gap-1.75 bg-white-dim px-2 py-1.5 rounded-2.5" to={homeLink}>
      <ResponsiveImage alt="" height={28} imageClassName="w-7" loading="eager" srcKey="icons/home-v2.png" width={28} />
      <span className="font-medium text-white text-base">{t('dashboard')}</span>
    </Link>
  )
}
